module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrap",
    class: ['search-select', {
      'widen': _vm.isWiden,
      'is-focus': _vm.input.focus
    }],
    on: {
      "click": _vm.handleWrapClick
    }
  }, [_c('div', {
    staticClass: "search-input",
    style: ({
      maxHeight: (_vm.shrink ? (_vm.input.focus ? _vm.maxHeight : _vm.minHeight) : _vm.maxHeight) + 'px'
    })
  }, [_vm._l((_vm.searchSelectValue), function(item, index) {
    return _c('div', {
      key: index,
      class: ['select-tags', {
        'active': item.isSelect
      }],
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onClickSelectTag(item.id, item.values)
        }
      }
    }, [_c('el-popover', {
      ref: "selectPopover",
      refInFor: true,
      attrs: {
        "placement": "bottom",
        "popper-class": "select-list-popover",
        "trigger": "click",
        "value": item.isSelect
      },
      on: {
        "hide": function($event) {
          return _vm.handleSelectPopHidden(item.id)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    }, [_c('span', [_vm._v(_vm._s(item.name + '：'))]), _vm._v(" "), _vm._l((item.values), function(val, idx) {
      return _c('span', {
        key: idx,
        staticClass: "val-item"
      }, [_vm._v("\n                        " + _vm._s(val) + "\n                        "), (idx !== item.values.length - 1) ? _c('span', {
        staticClass: "separation-line"
      }) : _vm._e()])
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onClearSelectTag(item.id)
        }
      }
    })], 2), _vm._v(" "), _c('ul', _vm._l((item.values), function(val, valIndex) {
      return _c('li', {
        key: valIndex,
        staticClass: "select-list-menu-item",
        on: {
          "click": function($event) {
            return _vm.onClearSelectTag(item.id, val)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(val) + "\n                        "), (_vm.selectValues.includes(val)) ? _c('i', {
        staticClass: "el-icon-check"
      }) : _vm._e()])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "select-list-footer"
    }, [_c('span', {
      staticClass: "footer-btn",
      on: {
        "click": function($event) {
          return _vm.handleConfirm(item.id)
        }
      }
    }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
      staticClass: "footer-btn",
      on: {
        "click": function($event) {
          return _vm.handleSelectPopHidden(item.id, true)
        }
      }
    }, [_vm._v("取消")])])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "search-input-input"
  }, [_c('div', {
    ref: "input",
    staticClass: "div-input",
    class: {
      'input-before': _vm.isShowPlaceholder
    },
    attrs: {
      "contenteditable": "plaintext-only",
      "data-placeholder": _vm.placeholder
    },
    on: {
      "click": _vm.handleInputClick,
      "focus": _vm.handleInputFocus,
      "blur": _vm.handleInputBlur,
      "input": _vm.handleInputChange,
      "keydown": _vm.handleInputKeyup
    }
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "popper-class": "search-list-popover",
      "trigger": "manual"
    },
    on: {
      "hidden": _vm.handleSeachPopHidden
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('span', {
    staticClass: "search-list-menu",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }), _vm._v(" "), (_vm.selectInfo && _vm.selectInfo.id === 'tag') ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isTagsLoading),
      expression: "isTagsLoading"
    }],
    ref: "tagPopover",
    staticClass: "search-list-content"
  }, [_c('el-input', {
    staticClass: "tag-input",
    attrs: {
      "placeholder": "请输入内容"
    },
    on: {
      "change": _vm.onTagsInputChange
    },
    model: {
      value: (_vm.tagText),
      callback: function($$v) {
        _vm.tagText = $$v
      },
      expression: "tagText"
    }
  }, [_c('img', {
    attrs: {
      "slot": "prefix",
      "src": require("../../images/community/search.png")
    },
    slot: "prefix"
  })]), _vm._v(" "), _c('ul', {
    ref: "tagList",
    staticClass: "tag-content"
  }, [_vm._l((_vm.tagsList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "tag-content-menu-item",
      on: {
        "click": function($event) {
          return _vm.onSelectTags(item.title)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.title) + "\n                            "), (_vm.selectTagList.includes(item.title)) ? _c('i', {
      staticClass: "el-icon-check"
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.isLoading) ? _c('li', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticClass: "tag-content-menu-item scroll-loading"
  }) : _vm._e(), _vm._v(" "), (!_vm.tagsList.length && !_vm.isTagsLoading) ? _c('li', {
    staticClass: "data-null"
  }, [_vm._v("暂无数据")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagsList.length),
      expression: "tagsList.length"
    }],
    staticClass: "tag-content-footer"
  }, [_c('span', {
    staticClass: "footer-btn",
    on: {
      "click": _vm.handleSelectTagsConfirm
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    staticClass: "footer-btn",
    on: {
      "click": _vm.handleSeachPopHidden
    }
  }, [_vm._v("取消")])])], 1) : _c('ul', {
    staticClass: "search-list-menu"
  }, [_vm._l((_vm.searchList), function(item, index) {
    return [(item.isShow) ? _c('li', {
      key: index,
      class: ['search-list-menu-item', {
        'active': item.id === _vm.selectInfo.id
      }],
      on: {
        "click": function($event) {
          return _vm.onSelect(item)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")]) : _vm._e()]
  })], 2)])], 1)], 2), _vm._v(" "), (_vm.input.value || _vm.searchSelectValue.length) ? _c('span', {
    class: ['close-icon', {
      'is-close': _vm.input.value
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClear.apply(null, arguments)
      }
    }
  }) : _c('span', {
    class: ['search-icon', {
      'is-focus': _vm.input.focus
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleKeyEnter.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-279dd7c8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/searchSelect.vue
// module id = WljR
// module chunks = 15